var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDe = function SvgIconDe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M.746 16.175C2.442 20.745 6.84 24 12 24s9.558-3.257 11.253-7.826L12 15.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 0C6.84 0 2.442 3.258.746 7.828L12 8.87l11.253-1.043C21.558 3.257 17.16 0 12 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M.746 7.826A12 12 0 0 0 0 12c0 1.467.264 2.874.746 4.174h22.508c.482-1.3.746-2.707.746-4.174s-.264-2.874-.746-4.174z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconDe;